import { render, staticRenderFns } from "./CustomerGroupRemoved.vue?vue&type=template&id=79e691a4&scoped=true"
import script from "./CustomerGroupRemoved.vue?vue&type=script&lang=js"
export * from "./CustomerGroupRemoved.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79e691a4",
  null
  
)

export default component.exports